import { render, staticRenderFns } from "./orderThen.vue?vue&type=template&id=6ff1e3c5&"
import script from "./orderThen.vue?vue&type=script&lang=js&"
export * from "./orderThen.vue?vue&type=script&lang=js&"
import style0 from "./orderThen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports